import i18n from '@/utils/i18n';

const fields =
    [
      {
        name: "created_at",
        label: i18n.t('form.created_at'),
        type: "date",
        mode: 'date',
        "is-range": false
      },
      {
        name: "bundle",
        type: "select",
        label: i18n.t('form.bundles'),
        searchable: true,
        multiple: true,
        placeholder: i18n.t('transactions.type_to_search'),
        options_url: "bundles?limit=10",
        filter_field: 'title',
      },
      {
        name: "content",
        type: "select",
        label: i18n.t('dashboard.content'),
        searchable: true,
        multiple: true,
        placeholder: i18n.t('transactions.type_to_search'),
        options_url: "content?limit=10",
        filter_field: 'title',
      },
      {
        name: "subscription",
        type: "select",
        label: i18n.t('form.subscriptions_id'),
        searchable: true,
        multiple: true,
        placeholder: i18n.t('transactions.type_to_search'),
        group: true,
        options_url: "plans?limit=100",
        filter_field: 'title',
      },
      {
        name: "livemode",
        type: "checkbox",
        label: i18n.t('resources.live_mode'),
      },
      {
          name: "ti_event_ticket_pass",
          type: "select",
          label: i18n.t('form.events_and_tickets'),
          searchable: true,
          multiple: true,
          placeholder: i18n.t('transactions.type_to_search'),
          group: true,
          options_url: "ti-events?limit=100",
          filter_field: 'title',
          items_key: 'tickets'
      },
    ];

export default fields
